import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createLeadShifts } from 'api/shift'
import { useAuthContext } from 'components/auth'
import { MutationOptions, QueryFnParams } from 'queries/types'
import { leadShiftsKey } from './keys'

type CreateLeadShiftsVariables = Omit<
  QueryFnParams<typeof createLeadShifts>[0],
  'companyId' | 'shiftId'
>

export function useCreateLeadShiftsMutation(
  shiftId: number,
  options: MutationOptions<
    typeof createLeadShifts,
    unknown[],
    CreateLeadShiftsVariables
  > = {}
) {
  const queryClient = useQueryClient()
  const { company } = useAuthContext()

  return useMutation({
    ...options,
    mutationFn: (variables: CreateLeadShiftsVariables) => {
      if (!company?.id) {
        throw new Error('Company is required')
      }
      return createLeadShifts({ ...variables, companyId: company.id, shiftId })
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: leadShiftsKey(shiftId) })
      return options.onSuccess?.(...args)
    },
  })
}
